import { useEffect, useState } from "react";

// useTurnCredentials.js
export function useTurnCredentials() {
  const [iceServers, setIceServers] = useState(null);

  useEffect(() => {
    const fetchCredentials = async () => {
      try {
        const res = await fetch(
          `https://rtc.live.cloudflare.com/v1/turn/keys/${
            process.env.REACT_APP_TURN_TOKEN
          }/credentials/generate-ice-servers`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ ttl: 86400 }),
          }
        );
        const data = await res.json();
        // console.log('ICE servers loaded:', data.iceServers); // ← check this

        setIceServers(data.iceServers);
      } catch (err) {
        console.error('Failed to fetch TURN credentials:', err);
        setIceServers([{ urls: "stun:stun.l.google.com:19302" }]);
      }
    };

    fetchCredentials();
  }, []);

  return iceServers;
}
